import Glide from '@glidejs/glide';
import { RTJS_lightbox } from '@rtsoft/rtjs';
import '../../polyfills';
import { initProductFilter } from './product/product-filter';
// import { renderLightBox } from './react/lightbox/lightbox'

function initProductAreaMassCalculator() {
    // výpočet z datasetu kolik kg je třeba na zadanou hodnotu v m²
    const input = document.getElementById('calculator-area');

    if (input !== null) {
        input.addEventListener('input', () => {
            const resultInput = document.getElementById('calculator-mass');
            const number = parseFloat(
                parseFloat(input.value.replace(/[^0-9.]/g, '')) * parseFloat(input.dataset.constant.replace(',', '.'))
            );

            // pokud uživatel zadá nesmysl, nepřepočítá, zaokrouhlení, aby nepřelézalo input
            const parsedNumber = isNaN(number) ? 0 : parseFloat(number.toFixed(2));
            resultInput.value = parsedNumber.toString().replace('.', ',') + ' ' + input.dataset.suffix;
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const sliders = {};

    // inicializace odstranění filtru
    initProductFilter();

    // zobrazit dalších x produktů )ajax tlačítko)

    const loadMoreProducts = document.getElementById('load-more-products');

    if (loadMoreProducts) {
        loadMoreProducts.addEventListener('click', (event) => {
            event.preventDefault();
            const el = event.target;
            el.classList.remove('btn--secondary');
            el.classList.add('btn--primary');
            el.querySelector('.spinner').classList.remove('d-none');

            // todo ajax volání a překreslení snippetu
        });
    }

    // inicializace slideru "podobné produkty"
    const carouselSimilar = document.querySelectorAll('.product-slider-similar-products');
    if (carouselSimilar) {
        carouselSimilar.forEach((element) => {
            const slidesPhysicalCount = element.querySelectorAll('.glide__slide').length;

            const perViewHandled = (items) => (items <= slidesPhysicalCount ? items : slidesPhysicalCount);

            const toggleArrows = () => {
                if (productSlider.settings.perView < slidesPhysicalCount) {
                    element.querySelector('.product-slider .product-slider__arrows').classList.remove('d-none');
                } else {
                    element.querySelector('.product-slider .product-slider__arrows').classList.add('d-none');
                }
            };

            // eslint-disable-next-line no-unused-vars
            const isDragable = () => {};

            const productSlider = new Glide(element, {
                autoplay: false,
                perView: perViewHandled(4),
                breakpoints: {
                    1200: {
                        perView: perViewHandled(4),
                    },
                    992: {
                        perView: perViewHandled(3),
                    },
                    768: {
                        perView: perViewHandled(2),
                    },
                    576: {
                        perView: 1,
                    },
                },
                type: 'carousel',
                gap: 0,
            });

            productSlider.on(['resize', 'mount.before'], () => {
                toggleArrows();
            });

            productSlider.mount();
        });
    }

    // inicializace slideru obrázků produktu (detail -> hlanví obrázek)

    if (document.body.querySelector('.product-main-image')) {
        sliders.productMainSlider = new Glide('.product-main-image', {
            autoplay: false,
            perView: 1,
            type: 'carousel',
            gap: 0,
        });

        sliders.productMainSlider.on('run', () => {
            sliders.productMainThumbsSlider.go('=' + sliders.productMainSlider.index);
        });

        // RT lightbox

        RTJS_lightbox('.product-main-image__slider .glide__slide', {
            // closeLabel: 'zavřít',
            // showTitle: true,
            // showArrows: true,
            // showThumbnails: true,
            // debug: false,
            // imageErrorLabel: 'obrázek se nepodařilo načíst',
        });

        sliders.productMainSlider.mount();

        const thumbnailsEl = document.getElementById('gallery-thumbnails__slider');

        sliders.productMainThumbsSlider = new Glide('.gallery-thumbnails', {
            autoplay: false,
            perView: thumbnailsEl.dataset.sliderMaxCount < 7 ? thumbnailsEl.dataset.sliderMaxCount : 7,
            type: 'carousel',
            gap: 20,
            breakpoints: {
                1200: {
                    perView: thumbnailsEl.dataset.sliderMaxCount < 7 ? thumbnailsEl.dataset.sliderMaxCount : 7,
                },
                // 992: {
                //     perView: thumbnailsEl.dataset.sliderMaxCount < 5 ? thumbnailsEl.dataset.sliderMaxCount : 5
                // },
                768: {
                    perView: thumbnailsEl.dataset.sliderMaxCount < 5 ? thumbnailsEl.dataset.sliderMaxCount : 5,
                },
                576: {
                    perView: thumbnailsEl.dataset.sliderMaxCount < 3 ? thumbnailsEl.dataset.sliderMaxCount : 3,
                },
            },
        });

        sliders.productMainThumbsSlider.on('mount.after', () => {
            document.body.querySelector('.gallery-thumbnails').classList.add('gallery-thumbnails--visible');
        });

        document.body.querySelector('.gallery-thumbnails__track').addEventListener('click', (event) => {
            event.preventDefault();
            sliders.productMainThumbsSlider.go('=' + event.target.closest('li').dataset.index);
        });

        sliders.productMainThumbsSlider.on('run', () => {
            sliders.productMainSlider.go('=' + sliders.productMainThumbsSlider.index);
        });

        sliders.productMainThumbsSlider.mount();
    }

    initProductAreaMassCalculator();
});
